/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Page Groups 

import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "./resourceTypeConstants";
import {
	UserAccountPage,
	UserAccountBalancePage,
	UserAccountBalanceSourcePage,
	UserHistoryEntryPage,
	BalanceChangeLogPage,
	InternationalUserBankAccountPage,
	USDomesticUserBankAccountPage,
	UserBankAccountDeltaPage,
	UserAccountSettingsPage,
	AdminGhostUserAccountPage,
	UserAccountFinalizationPage,
	ThirdPartyUserAccountMappingPage,
	PreviousEmailAddressPage,
	PendingEmailChangePage,
	ArchivedPendingEmailChangePage,
	PasswordPage,
	ExpiredPasswordPage,
	PasswordResetPage,
	DepositPage,
	DepositInvitePage,
	DepositAdjustmentPage,
	DepositInterestPage,
	DepositHistoryEntryPage,
	DepositCloseRequestPage,
	DepositUserStatsPage,
	DepositBankMappingPage,
	DepositBulkImportPage,
	DepositInterestLogPage,
	ArchivedDepositCloseRequestPage,
	DepositWithheldFundsPage,
	PMCReportTimetablePage,
	DepositGroupPage,
	DepositPostCloseAdjustmentPage,
	DepositUserGroupPage,
	PropertyGroupPage,
	PropertyUserGroupPage,
	DisputePage,
	DisputeSplitPage,
	DisputeInterventionRequestPage,
	PropertyPage,
	PropertyAddressPage,
	CompliancePage,
	ComplianceRulePage,
	ComplianceHistoryPage,
	EmailTemplatePage,
	EmailVerificationPage,
	EmailVerificationRecordPage,
	EmailEventPage,
	SentEmailPage,
	MailboxPage,
	MailboxMetaDataPage,
	MailboxMessagePage,
	PermissionEntryPage,
	PermissionLogEntryPage,
	PermissionsOrganizationSettingsPage,
	ResourcePermissionPage,
	OrganizationPage,
	OrganizationResourcePermissionRulePage,
	InvoicePage,
	InvoiceItemPage,
	PaymentRequestPage,
	StripePaymentLogPage,
	UserWithdrawPage,
	PriorityACHPaymentPage,
	PriorityACHRecurringPaymentPage,
	LoanApplicationPage,
	LoanSystemInfoPage,
	LoanPage,
	LoanHistoryPage,
	LoanPaymentLogPage,
	StripeWebhookLogPage,
	UserAccountPaymentProviderInfoPage,
	SezzleOrderPage,
	SezzleWebhookEventPage,
	BankAccountPage,
	BankAccountHistoricalInterestRatePage,
	BankAccountInterestPage,
	BankAccountBalanceRecordPage,
	BankTransferPage,
	BulkFundsTransferPage,
	FundsLockPage,
	FundsLockReleaseLogPage,
	ReleasedFundsLockPage,
	BalanceSourceTransferPage,
	CreditUserAccountLogPage,
	EventPage,
	EventHookPage,
	NotificationPage,
	ActionItemPage,
	UpdateLogPage,
	StorageFilePage,
	AttachedStorageFilesPage,
	SystemHistoryEntryPage,
	SnapshotPage,
	IPAddressPage,
	KnownIPAddressPage,
	UserAgentPage,
	KnownUserAgentPage,
	SystemStatsPage,
	ResourceNotePage,
	DeposifyTagPage,
	PermanentLinkPage,
	OnlineUserPage,
	FrontendGeneralSettingsPage,
	YardiScreeningWorksProXMLPage,
	YardiVoyagerXMLPage,
	YardiVoyagerTransactionPage,
	YardiVoyagerResidentPage,
	YardiVoyagerResidentCustomColumnPage,
	YardiVoyagerPropertyUnitPage,
	YardiVoyagerPropertyPage,
	YardiVoyagerPMCServiceInterfaceVersionPage,
	YardiVoyagerPMCPage,
	YardiVoyagerPMCCredentialsPage,
	YardiVoyagerPetPage,
	YardiVoyagerILSGuestCardEventPage,
	YardiVoyagerChargePage,
	YardiVoyagerChargeCodePage,
	YardiVoyagerDepositCreateIntentPage,
	YardiVoyagerDepositCloseIntentPage,
	YardiVoyagerDepositWithholdIntentPage,
	YardiVoyagerEventPage,
	YardiVoyagerFlexDepositIntentPage,
	YardiVoyagerPhonePage,
	YardiVoyagerOtherOccupantPage,
	YardiVoyagerPMCCustomColumnSettingsPage,
	YardiVoyagerPMCStatsPage,
	YardiVoyagerPMCStatsCollectorPage,
	YardiVoyagerActiveScanLogEntryPage,
	YardiVoyagerSystemSettingsPage
} from "../components/pages/allObjectPages";

import {
	USER_ACCOUNT_ROUTE,
	USER_ACCOUNT_BALANCE_ROUTE,
	USER_ACCOUNT_BALANCE_SOURCE_ROUTE,
	USER_HISTORY_ENTRY_ROUTE,
	BALANCE_CHANGE_LOG_ROUTE,
	INTERNATIONAL_USER_BANK_ACCOUNT_ROUTE,
	US_DOMESTIC_USER_BANK_ACCOUNT_ROUTE,
	USER_BANK_ACCOUNT_DELTA_ROUTE,
	USER_ACCOUNT_SETTINGS_ROUTE,
	ADMIN_GHOST_USER_ACCOUNT_ROUTE,
	USER_ACCOUNT_FINALIZATION_ROUTE,
	THIRD_PARTY_USER_ACCOUNT_MAPPING_ROUTE,
	PREVIOUS_EMAIL_ADDRESS_ROUTE,
	PENDING_EMAIL_CHANGE_ROUTE,
	ARCHIVED_PENDING_EMAIL_CHANGE_ROUTE,
	PASSWORD_ROUTE,
	EXPIRED_PASSWORD_ROUTE,
	PASSWORD_RESET_ROUTE,
	DEPOSIT_ROUTE,
	DEPOSIT_INVITE_ROUTE,
	DEPOSIT_ADJUSTMENT_ROUTE,
	DEPOSIT_INTEREST_ROUTE,
	DEPOSIT_HISTORY_ENTRY_ROUTE,
	DEPOSIT_CLOSE_REQUEST_ROUTE,
	DEPOSIT_USER_STATS_ROUTE,
	DEPOSIT_BANK_MAPPING_ROUTE,
	DEPOSIT_BULK_IMPORT_ROUTE,
	DEPOSIT_INTEREST_LOG_ROUTE,
	ARCHIVED_DEPOSIT_CLOSE_REQUEST_ROUTE,
	DEPOSIT_WITHHELD_FUNDS_ROUTE,
	PMC_REPORT_TIMETABLE_ROUTE,
	DEPOSIT_GROUP_ROUTE,
	DEPOSIT_POST_CLOSE_ADJUSTMENT_ROUTE,
	DEPOSIT_USER_GROUP_ROUTE,
	PROPERTY_GROUP_ROUTE,
	PROPERTY_USER_GROUP_ROUTE,
	DISPUTE_ROUTE,
	DISPUTE_SPLIT_ROUTE,
	DISPUTE_INTERVENTION_REQUEST_ROUTE,
	PROPERTY_ROUTE,
	PROPERTY_ADDRESS_ROUTE,
	COMPLIANCE_ROUTE,
	COMPLIANCE_RULE_ROUTE,
	COMPLIANCE_HISTORY_ROUTE,
	EMAIL_TEMPLATE_ROUTE,
	EMAIL_VERIFICATION_ROUTE,
	EMAIL_VERIFICATION_RECORD_ROUTE,
	EMAIL_EVENT_ROUTE,
	SENT_EMAIL_ROUTE,
	MAILBOX_ROUTE,
	MAILBOX_META_DATA_ROUTE,
	MAILBOX_MESSAGE_ROUTE,
	PERMISSION_ENTRY_ROUTE,
	PERMISSION_LOG_ENTRY_ROUTE,
	PERMISSIONS_ORGANIZATION_SETTINGS_ROUTE,
	RESOURCE_PERMISSION_ROUTE,
	ORGANIZATION_ROUTE,
	ORGANIZATION_RESOURCE_PERMISSION_RULE_ROUTE,
	INVOICE_ROUTE,
	INVOICE_ITEM_ROUTE,
	PAYMENT_REQUEST_ROUTE,
	STRIPE_PAYMENT_LOG_ROUTE,
	USER_WITHDRAW_ROUTE,
	PRIORITY_ACH_PAYMENT_ROUTE,
	PRIORITY_ACH_RECURRING_PAYMENT_ROUTE,
	LOAN_APPLICATION_ROUTE,
	LOAN_SYSTEM_INFO_ROUTE,
	LOAN_ROUTE,
	LOAN_HISTORY_ROUTE,
	LOAN_PAYMENT_LOG_ROUTE,
	STRIPE_WEBHOOK_LOG_ROUTE,
	USER_ACCOUNT_PAYMENT_PROVIDER_INFO_ROUTE,
	SEZZLE_ORDER_ROUTE,
	SEZZLE_WEBHOOK_EVENT_ROUTE,
	BANK_ACCOUNT_ROUTE,
	BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_ROUTE,
	BANK_ACCOUNT_INTEREST_ROUTE,
	BANK_ACCOUNT_BALANCE_RECORD_ROUTE,
	BANK_TRANSFER_ROUTE,
	BULK_FUNDS_TRANSFER_ROUTE,
	FUNDS_LOCK_ROUTE,
	FUNDS_LOCK_RELEASE_LOG_ROUTE,
	RELEASED_FUNDS_LOCK_ROUTE,
	BALANCE_SOURCE_TRANSFER_ROUTE,
	CREDIT_USER_ACCOUNT_LOG_ROUTE,
	EVENT_ROUTE,
	EVENT_HOOK_ROUTE,
	NOTIFICATION_ROUTE,
	ACTION_ITEM_ROUTE,
	UPDATE_LOG_ROUTE,
	STORAGE_FILE_ROUTE,
	ATTACHED_STORAGE_FILES_ROUTE,
	SYSTEM_HISTORY_ENTRY_ROUTE,
	SNAPSHOT_ROUTE,
	IP_ADDRESS_ROUTE,
	KNOWN_IP_ADDRESS_ROUTE,
	USER_AGENT_ROUTE,
	KNOWN_USER_AGENT_ROUTE,
	SYSTEM_STATS_ROUTE,
	RESOURCE_NOTE_ROUTE,
	DEPOSIFY_TAG_ROUTE,
	PERMANENT_LINK_ROUTE,
	ONLINE_USER_ROUTE,
	FRONTEND_GENERAL_SETTINGS_ROUTE,
	YARDI_SCREENING_WORKS_PRO_XML_ROUTE,
	YARDI_VOYAGER_XML_ROUTE,
	YARDI_VOYAGER_TRANSACTION_ROUTE,
	YARDI_VOYAGER_RESIDENT_ROUTE,
	YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_ROUTE,
	YARDI_VOYAGER_PROPERTY_UNIT_ROUTE,
	YARDI_VOYAGER_PROPERTY_ROUTE,
	YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_ROUTE,
	YARDI_VOYAGER_PMC_ROUTE,
	YARDI_VOYAGER_PMC_CREDENTIALS_ROUTE,
	YARDI_VOYAGER_PET_ROUTE,
	YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_ROUTE,
	YARDI_VOYAGER_CHARGE_ROUTE,
	YARDI_VOYAGER_CHARGE_CODE_ROUTE,
	YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_ROUTE,
	YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_ROUTE,
	YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_ROUTE,
	YARDI_VOYAGER_EVENT_ROUTE,
	YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_ROUTE,
	YARDI_VOYAGER_PHONE_ROUTE,
	YARDI_VOYAGER_OTHER_OCCUPANT_ROUTE,
	YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_ROUTE,
	YARDI_VOYAGER_PMC_STATS_ROUTE,
	YARDI_VOYAGER_PMC_STATS_COLLECTOR_ROUTE,
	YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_ROUTE,
	YARDI_VOYAGER_SYSTEM_SETTINGS_ROUTE
} from "./routes";



export const USER_ACCOUNTS_PAGE_GROUP = {
	[RESOURCE_TYPE_USER_ACCOUNT]: {route: USER_ACCOUNT_ROUTE},
	[RESOURCE_TYPE_USER_ACCOUNT_BALANCE]: {route: USER_ACCOUNT_BALANCE_ROUTE},
	[RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE]: {route: USER_ACCOUNT_BALANCE_SOURCE_ROUTE},
	[RESOURCE_TYPE_BALANCE_CHANGE_LOG]: {route: BALANCE_CHANGE_LOG_ROUTE},
	[RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT]: {route: INTERNATIONAL_USER_BANK_ACCOUNT_ROUTE},
	[RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT]: {route: US_DOMESTIC_USER_BANK_ACCOUNT_ROUTE},
	[RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA]: {route: USER_BANK_ACCOUNT_DELTA_ROUTE},
	[RESOURCE_TYPE_USER_ACCOUNT_SETTINGS]: {route: USER_ACCOUNT_SETTINGS_ROUTE},
	[RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST]: {route: ADMIN_GHOST_USER_ACCOUNT_ROUTE},
	[RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION]: {route: USER_ACCOUNT_FINALIZATION_ROUTE},
	[RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING]: {route: THIRD_PARTY_USER_ACCOUNT_MAPPING_ROUTE},
	[RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS]: {route: PREVIOUS_EMAIL_ADDRESS_ROUTE},
	[RESOURCE_TYPE_PENDING_EMAIL_CHANGE]: {route: PENDING_EMAIL_CHANGE_ROUTE},
	[RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE]: {route: ARCHIVED_PENDING_EMAIL_CHANGE_ROUTE},
	[RESOURCE_TYPE_PASSWORD]: {route: PASSWORD_ROUTE},
	[RESOURCE_TYPE_EXPIRED_PASSWORD]: {route: EXPIRED_PASSWORD_ROUTE},
	[RESOURCE_TYPE_PASSWORD_RESET]: {route: PASSWORD_RESET_ROUTE},
	[RESOURCE_TYPE_EMAIL_VERIFICATION]: {route: EMAIL_VERIFICATION_ROUTE},
	[RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD]: {route: EMAIL_VERIFICATION_RECORD_ROUTE},
	[RESOURCE_TYPE_FUNDS_LOCK]: {route: FUNDS_LOCK_ROUTE},
	[RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG]: {route: FUNDS_LOCK_RELEASE_LOG_ROUTE},
	[RESOURCE_TYPE_RELEASED_FUNDS_LOCK]: {route: RELEASED_FUNDS_LOCK_ROUTE},
	[RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER]: {route: BALANCE_SOURCE_TRANSFER_ROUTE},
	[RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG]: {route: CREDIT_USER_ACCOUNT_LOG_ROUTE},
};
export const HISTORY_PAGE_GROUP = {
	[RESOURCE_TYPE_USER_HISTORY_ENTRY]: {route: USER_HISTORY_ENTRY_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY]: {route: DEPOSIT_HISTORY_ENTRY_ROUTE},
	[RESOURCE_TYPE_UPDATE_LOG_ENTRY]: {route: UPDATE_LOG_ROUTE},
	[RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY]: {route: SYSTEM_HISTORY_ENTRY_ROUTE},
	[RESOURCE_TYPE_SNAPSHOT]: {route: SNAPSHOT_ROUTE},
};
export const DEPOSITS_PAGE_GROUP = {
	[RESOURCE_TYPE_DEPOSIT]: {route: DEPOSIT_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_INVITE]: {route: DEPOSIT_INVITE_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_ADJUSTMENT]: {route: DEPOSIT_ADJUSTMENT_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_INTEREST]: {route: DEPOSIT_INTEREST_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST]: {route: DEPOSIT_CLOSE_REQUEST_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_USER_STATS]: {route: DEPOSIT_USER_STATS_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_BANK_MAPPING]: {route: DEPOSIT_BANK_MAPPING_ROUTE},
	[RESOURCE_TYPE_DEPOSITS_BULK_IMPORT]: {route: DEPOSIT_BULK_IMPORT_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_INTEREST_LOG]: {route: DEPOSIT_INTEREST_LOG_ROUTE},
	[RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST]: {route: ARCHIVED_DEPOSIT_CLOSE_REQUEST_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS]: {route: DEPOSIT_WITHHELD_FUNDS_ROUTE},
	[RESOURCE_TYPE_PMC_REPORT_TIMETABLE]: {route: PMC_REPORT_TIMETABLE_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_GROUP]: {route: DEPOSIT_GROUP_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT]: {route: DEPOSIT_POST_CLOSE_ADJUSTMENT_ROUTE},
	[RESOURCE_TYPE_DEPOSIT_USER_GROUP]: {route: DEPOSIT_USER_GROUP_ROUTE},
	[RESOURCE_TYPE_PROPERTY_GROUP]: {route: PROPERTY_GROUP_ROUTE},
	[RESOURCE_TYPE_PROPERTY_USER_GROUP]: {route: PROPERTY_USER_GROUP_ROUTE},
	[RESOURCE_TYPE_DISPUTE]: {route: DISPUTE_ROUTE},
	[RESOURCE_TYPE_DISPUTE_SPLIT]: {route: DISPUTE_SPLIT_ROUTE},
	[RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST]: {route: DISPUTE_INTERVENTION_REQUEST_ROUTE},
	[RESOURCE_TYPE_PROPERTY]: {route: PROPERTY_ROUTE},
	[RESOURCE_TYPE_PROPERTY_ADDRESS]: {route: PROPERTY_ADDRESS_ROUTE},
	[RESOURCE_TYPE_COMPLIANCE]: {route: COMPLIANCE_ROUTE},
	[RESOURCE_TYPE_COMPLIANCE_RULE]: {route: COMPLIANCE_RULE_ROUTE},
	[RESOURCE_TYPE_COMPLIANCE_HISTORY]: {route: COMPLIANCE_HISTORY_ROUTE},
};
export const MESSAGING_PAGE_GROUP = {
	[RESOURCE_TYPE_EMAIL_TEMPLATE]: {route: EMAIL_TEMPLATE_ROUTE},
	[RESOURCE_TYPE_EMAIL_EVENT]: {route: EMAIL_EVENT_ROUTE},
	[RESOURCE_TYPE_SENT_EMAIL]: {route: SENT_EMAIL_ROUTE},
	[RESOURCE_TYPE_MAILBOX]: {route: MAILBOX_ROUTE},
	[RESOURCE_TYPE_MAILBOX_META_DATA]: {route: MAILBOX_META_DATA_ROUTE},
	[RESOURCE_TYPE_MAILBOX_MESSAGE]: {route: MAILBOX_MESSAGE_ROUTE},
};
export const PERMISSIONS_PAGE_GROUP = {
	[RESOURCE_TYPE_PERMISSION_ENTRY]: {route: PERMISSION_ENTRY_ROUTE},
	[RESOURCE_TYPE_PERMISSION_LOG_ENTRY]: {route: PERMISSION_LOG_ENTRY_ROUTE},
	[RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS]: {route: PERMISSIONS_ORGANIZATION_SETTINGS_ROUTE},
	[RESOURCE_TYPE_RESOURCE_PERMISSIONS]: {route: RESOURCE_PERMISSION_ROUTE},
	[RESOURCE_TYPE_ORGANIZATION]: {route: ORGANIZATION_ROUTE},
	[RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE]: {route: ORGANIZATION_RESOURCE_PERMISSION_RULE_ROUTE},
};
export const PAYMENTS_PAGE_GROUP = {
	[RESOURCE_TYPE_INVOICE]: {route: INVOICE_ROUTE},
	[RESOURCE_TYPE_INVOICE_ITEM]: {route: INVOICE_ITEM_ROUTE},
	[RESOURCE_TYPE_PAYMENT_REQUEST]: {route: PAYMENT_REQUEST_ROUTE},
	[RESOURCE_TYPE_STRIPE_PAYMENT_LOG]: {route: STRIPE_PAYMENT_LOG_ROUTE},
	[RESOURCE_TYPE_USER_WITHDRAW]: {route: USER_WITHDRAW_ROUTE},
	[RESOURCE_TYPE_PRIORITY_ACH_PAYMENT]: {route: PRIORITY_ACH_PAYMENT_ROUTE},
	[RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT]: {route: PRIORITY_ACH_RECURRING_PAYMENT_ROUTE},
	[RESOURCE_TYPE_LOAN_APPLICATION]: {route: LOAN_APPLICATION_ROUTE},
	[RESOURCE_TYPE_LOAN_SYSTEM_INFO]: {route: LOAN_SYSTEM_INFO_ROUTE},
	[RESOURCE_TYPE_LOAN]: {route: LOAN_ROUTE},
	[RESOURCE_TYPE_LOAN_HISTORY]: {route: LOAN_HISTORY_ROUTE},
	[RESOURCE_TYPE_LOAN_PAYMENT_LOG]: {route: LOAN_PAYMENT_LOG_ROUTE},
	[RESOURCE_TYPE_STRIPE_WEBHOOK_LOG]: {route: STRIPE_WEBHOOK_LOG_ROUTE},
	[RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO]: {route: USER_ACCOUNT_PAYMENT_PROVIDER_INFO_ROUTE},
	[RESOURCE_TYPE_SEZZLE_ORDER]: {route: SEZZLE_ORDER_ROUTE},
	[RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT]: {route: SEZZLE_WEBHOOK_EVENT_ROUTE},
};
export const BANKING_PAGE_GROUP = {
	[RESOURCE_TYPE_BANK_ACCOUNT]: {route: BANK_ACCOUNT_ROUTE},
	[RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE]: {route: BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_ROUTE},
	[RESOURCE_TYPE_BANK_ACCOUNT_INTEREST]: {route: BANK_ACCOUNT_INTEREST_ROUTE},
	[RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD]: {route: BANK_ACCOUNT_BALANCE_RECORD_ROUTE},
	[RESOURCE_TYPE_BANK_TRANSFER]: {route: BANK_TRANSFER_ROUTE},
	[RESOURCE_TYPE_BULK_FUNDS_TRANSFER]: {route: BULK_FUNDS_TRANSFER_ROUTE},
};
export const EVENTS_PAGE_GROUP = {
	[RESOURCE_TYPE_EVENT]: {route: EVENT_ROUTE},
	[RESOURCE_TYPE_EVENT_HOOK]: {route: EVENT_HOOK_ROUTE},
	[RESOURCE_TYPE_NOTIFICATION]: {route: NOTIFICATION_ROUTE},
	[RESOURCE_TYPE_ACTION_ITEM]: {route: ACTION_ITEM_ROUTE},
};
export const STORAGE_PAGE_GROUP = {
	[RESOURCE_TYPE_STORAGE_FILE]: {route: STORAGE_FILE_ROUTE},
	[RESOURCE_TYPE_ATTACHED_STORAGE_FILES]: {route: ATTACHED_STORAGE_FILES_ROUTE},
};
export const SECURITY_PAGE_GROUP = {
	[RESOURCE_TYPE_IP_ADDRESS]: {route: IP_ADDRESS_ROUTE},
	[RESOURCE_TYPE_KNOWN_IP_ADDRESS]: {route: KNOWN_IP_ADDRESS_ROUTE},
	[RESOURCE_TYPE_USER_AGENT]: {route: USER_AGENT_ROUTE},
	[RESOURCE_TYPE_KNOWN_USER_AGENT]: {route: KNOWN_USER_AGENT_ROUTE},
};
export const SYSTEM_GENERAL_PAGE_GROUP = {
	[RESOURCE_TYPE_SYSTEM_STATS]: {route: SYSTEM_STATS_ROUTE},
	[RESOURCE_TYPE_RESOURCE_NOTE]: {route: RESOURCE_NOTE_ROUTE},
	[RESOURCE_TYPE_DEPOSIFY_TAG]: {route: DEPOSIFY_TAG_ROUTE},
	[RESOURCE_TYPE_PERMANENT_LINK]: {route: PERMANENT_LINK_ROUTE},
};
export const FRONTEND_PAGE_GROUP = {
	[RESOURCE_TYPE_ONLINE_USER]: {route: ONLINE_USER_ROUTE},
	[RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS]: {route: FRONTEND_GENERAL_SETTINGS_ROUTE},
};
export const YARDI_PAGE_GROUP = {
	[RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML]: {route: YARDI_SCREENING_WORKS_PRO_XML_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_XML]: {route: YARDI_VOYAGER_XML_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION]: {route: YARDI_VOYAGER_TRANSACTION_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT]: {route: YARDI_VOYAGER_RESIDENT_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN]: {route: YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT]: {route: YARDI_VOYAGER_PROPERTY_UNIT_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY]: {route: YARDI_VOYAGER_PROPERTY_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION]: {route: YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC]: {route: YARDI_VOYAGER_PMC_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS]: {route: YARDI_VOYAGER_PMC_CREDENTIALS_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PET]: {route: YARDI_VOYAGER_PET_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT]: {route: YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE]: {route: YARDI_VOYAGER_CHARGE_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE]: {route: YARDI_VOYAGER_CHARGE_CODE_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT]: {route: YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT]: {route: YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT]: {route: YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_EVENT]: {route: YARDI_VOYAGER_EVENT_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT]: {route: YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PHONE]: {route: YARDI_VOYAGER_PHONE_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT]: {route: YARDI_VOYAGER_OTHER_OCCUPANT_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS]: {route: YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS]: {route: YARDI_VOYAGER_PMC_STATS_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR]: {route: YARDI_VOYAGER_PMC_STATS_COLLECTOR_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY]: {route: YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_ROUTE},
	[RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS]: {route: YARDI_VOYAGER_SYSTEM_SETTINGS_ROUTE},
};

export const ALL_PAGE_GROUPS = {
	banking: BANKING_PAGE_GROUP,
	deposits: DEPOSITS_PAGE_GROUP,
	events: EVENTS_PAGE_GROUP,
	frontend: FRONTEND_PAGE_GROUP,
	history: HISTORY_PAGE_GROUP,
	messaging: MESSAGING_PAGE_GROUP,
	payments: PAYMENTS_PAGE_GROUP,
	permissions: PERMISSIONS_PAGE_GROUP,
	security: SECURITY_PAGE_GROUP,
	storage: STORAGE_PAGE_GROUP,
	system_general: SYSTEM_GENERAL_PAGE_GROUP,
	user_accounts: USER_ACCOUNTS_PAGE_GROUP,
	yardi: YARDI_PAGE_GROUP,
};


export const ALL_RESOURCE_PAGE_ROUTES = {
	[USER_ACCOUNT_ROUTE]: {page_name: UserAccountPage, resource_type: RESOURCE_TYPE_USER_ACCOUNT},
	[USER_ACCOUNT_BALANCE_ROUTE]: {page_name: UserAccountBalancePage, resource_type: RESOURCE_TYPE_USER_ACCOUNT_BALANCE},
	[USER_ACCOUNT_BALANCE_SOURCE_ROUTE]: {page_name: UserAccountBalanceSourcePage, resource_type: RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE},
	[USER_HISTORY_ENTRY_ROUTE]: {page_name: UserHistoryEntryPage, resource_type: RESOURCE_TYPE_USER_HISTORY_ENTRY},
	[BALANCE_CHANGE_LOG_ROUTE]: {page_name: BalanceChangeLogPage, resource_type: RESOURCE_TYPE_BALANCE_CHANGE_LOG},
	[INTERNATIONAL_USER_BANK_ACCOUNT_ROUTE]: {page_name: InternationalUserBankAccountPage, resource_type: RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT},
	[US_DOMESTIC_USER_BANK_ACCOUNT_ROUTE]: {page_name: USDomesticUserBankAccountPage, resource_type: RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT},
	[USER_BANK_ACCOUNT_DELTA_ROUTE]: {page_name: UserBankAccountDeltaPage, resource_type: RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA},
	[USER_ACCOUNT_SETTINGS_ROUTE]: {page_name: UserAccountSettingsPage, resource_type: RESOURCE_TYPE_USER_ACCOUNT_SETTINGS},
	[ADMIN_GHOST_USER_ACCOUNT_ROUTE]: {page_name: AdminGhostUserAccountPage, resource_type: RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST},
	[USER_ACCOUNT_FINALIZATION_ROUTE]: {page_name: UserAccountFinalizationPage, resource_type: RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION},
	[THIRD_PARTY_USER_ACCOUNT_MAPPING_ROUTE]: {page_name: ThirdPartyUserAccountMappingPage, resource_type: RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING},
	[PREVIOUS_EMAIL_ADDRESS_ROUTE]: {page_name: PreviousEmailAddressPage, resource_type: RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS},
	[PENDING_EMAIL_CHANGE_ROUTE]: {page_name: PendingEmailChangePage, resource_type: RESOURCE_TYPE_PENDING_EMAIL_CHANGE},
	[ARCHIVED_PENDING_EMAIL_CHANGE_ROUTE]: {page_name: ArchivedPendingEmailChangePage, resource_type: RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE},
	[PASSWORD_ROUTE]: {page_name: PasswordPage, resource_type: RESOURCE_TYPE_PASSWORD},
	[EXPIRED_PASSWORD_ROUTE]: {page_name: ExpiredPasswordPage, resource_type: RESOURCE_TYPE_EXPIRED_PASSWORD},
	[PASSWORD_RESET_ROUTE]: {page_name: PasswordResetPage, resource_type: RESOURCE_TYPE_PASSWORD_RESET},
	[DEPOSIT_ROUTE]: {page_name: DepositPage, resource_type: RESOURCE_TYPE_DEPOSIT},
	[DEPOSIT_INVITE_ROUTE]: {page_name: DepositInvitePage, resource_type: RESOURCE_TYPE_DEPOSIT_INVITE},
	[DEPOSIT_ADJUSTMENT_ROUTE]: {page_name: DepositAdjustmentPage, resource_type: RESOURCE_TYPE_DEPOSIT_ADJUSTMENT},
	[DEPOSIT_INTEREST_ROUTE]: {page_name: DepositInterestPage, resource_type: RESOURCE_TYPE_DEPOSIT_INTEREST},
	[DEPOSIT_HISTORY_ENTRY_ROUTE]: {page_name: DepositHistoryEntryPage, resource_type: RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY},
	[DEPOSIT_CLOSE_REQUEST_ROUTE]: {page_name: DepositCloseRequestPage, resource_type: RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST},
	[DEPOSIT_USER_STATS_ROUTE]: {page_name: DepositUserStatsPage, resource_type: RESOURCE_TYPE_DEPOSIT_USER_STATS},
	[DEPOSIT_BANK_MAPPING_ROUTE]: {page_name: DepositBankMappingPage, resource_type: RESOURCE_TYPE_DEPOSIT_BANK_MAPPING},
	[DEPOSIT_BULK_IMPORT_ROUTE]: {page_name: DepositBulkImportPage, resource_type: RESOURCE_TYPE_DEPOSITS_BULK_IMPORT},
	[DEPOSIT_INTEREST_LOG_ROUTE]: {page_name: DepositInterestLogPage, resource_type: RESOURCE_TYPE_DEPOSIT_INTEREST_LOG},
	[ARCHIVED_DEPOSIT_CLOSE_REQUEST_ROUTE]: {page_name: ArchivedDepositCloseRequestPage, resource_type: RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST},
	[DEPOSIT_WITHHELD_FUNDS_ROUTE]: {page_name: DepositWithheldFundsPage, resource_type: RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS},
	[PMC_REPORT_TIMETABLE_ROUTE]: {page_name: PMCReportTimetablePage, resource_type: RESOURCE_TYPE_PMC_REPORT_TIMETABLE},
	[DEPOSIT_GROUP_ROUTE]: {page_name: DepositGroupPage, resource_type: RESOURCE_TYPE_DEPOSIT_GROUP},
	[DEPOSIT_POST_CLOSE_ADJUSTMENT_ROUTE]: {page_name: DepositPostCloseAdjustmentPage, resource_type: RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT},
	[DEPOSIT_USER_GROUP_ROUTE]: {page_name: DepositUserGroupPage, resource_type: RESOURCE_TYPE_DEPOSIT_USER_GROUP},
	[PROPERTY_GROUP_ROUTE]: {page_name: PropertyGroupPage, resource_type: RESOURCE_TYPE_PROPERTY_GROUP},
	[PROPERTY_USER_GROUP_ROUTE]: {page_name: PropertyUserGroupPage, resource_type: RESOURCE_TYPE_PROPERTY_USER_GROUP},
	[DISPUTE_ROUTE]: {page_name: DisputePage, resource_type: RESOURCE_TYPE_DISPUTE},
	[DISPUTE_SPLIT_ROUTE]: {page_name: DisputeSplitPage, resource_type: RESOURCE_TYPE_DISPUTE_SPLIT},
	[DISPUTE_INTERVENTION_REQUEST_ROUTE]: {page_name: DisputeInterventionRequestPage, resource_type: RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST},
	[PROPERTY_ROUTE]: {page_name: PropertyPage, resource_type: RESOURCE_TYPE_PROPERTY},
	[PROPERTY_ADDRESS_ROUTE]: {page_name: PropertyAddressPage, resource_type: RESOURCE_TYPE_PROPERTY_ADDRESS},
	[COMPLIANCE_ROUTE]: {page_name: CompliancePage, resource_type: RESOURCE_TYPE_COMPLIANCE},
	[COMPLIANCE_RULE_ROUTE]: {page_name: ComplianceRulePage, resource_type: RESOURCE_TYPE_COMPLIANCE_RULE},
	[COMPLIANCE_HISTORY_ROUTE]: {page_name: ComplianceHistoryPage, resource_type: RESOURCE_TYPE_COMPLIANCE_HISTORY},
	[EMAIL_TEMPLATE_ROUTE]: {page_name: EmailTemplatePage, resource_type: RESOURCE_TYPE_EMAIL_TEMPLATE},
	[EMAIL_VERIFICATION_ROUTE]: {page_name: EmailVerificationPage, resource_type: RESOURCE_TYPE_EMAIL_VERIFICATION},
	[EMAIL_VERIFICATION_RECORD_ROUTE]: {page_name: EmailVerificationRecordPage, resource_type: RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD},
	[EMAIL_EVENT_ROUTE]: {page_name: EmailEventPage, resource_type: RESOURCE_TYPE_EMAIL_EVENT},
	[SENT_EMAIL_ROUTE]: {page_name: SentEmailPage, resource_type: RESOURCE_TYPE_SENT_EMAIL},
	[MAILBOX_ROUTE]: {page_name: MailboxPage, resource_type: RESOURCE_TYPE_MAILBOX},
	[MAILBOX_META_DATA_ROUTE]: {page_name: MailboxMetaDataPage, resource_type: RESOURCE_TYPE_MAILBOX_META_DATA},
	[MAILBOX_MESSAGE_ROUTE]: {page_name: MailboxMessagePage, resource_type: RESOURCE_TYPE_MAILBOX_MESSAGE},
	[PERMISSION_ENTRY_ROUTE]: {page_name: PermissionEntryPage, resource_type: RESOURCE_TYPE_PERMISSION_ENTRY},
	[PERMISSION_LOG_ENTRY_ROUTE]: {page_name: PermissionLogEntryPage, resource_type: RESOURCE_TYPE_PERMISSION_LOG_ENTRY},
	[PERMISSIONS_ORGANIZATION_SETTINGS_ROUTE]: {page_name: PermissionsOrganizationSettingsPage, resource_type: RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS},
	[RESOURCE_PERMISSION_ROUTE]: {page_name: ResourcePermissionPage, resource_type: RESOURCE_TYPE_RESOURCE_PERMISSIONS},
	[ORGANIZATION_ROUTE]: {page_name: OrganizationPage, resource_type: RESOURCE_TYPE_ORGANIZATION},
	[ORGANIZATION_RESOURCE_PERMISSION_RULE_ROUTE]: {page_name: OrganizationResourcePermissionRulePage, resource_type: RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE},
	[INVOICE_ROUTE]: {page_name: InvoicePage, resource_type: RESOURCE_TYPE_INVOICE},
	[INVOICE_ITEM_ROUTE]: {page_name: InvoiceItemPage, resource_type: RESOURCE_TYPE_INVOICE_ITEM},
	[PAYMENT_REQUEST_ROUTE]: {page_name: PaymentRequestPage, resource_type: RESOURCE_TYPE_PAYMENT_REQUEST},
	[STRIPE_PAYMENT_LOG_ROUTE]: {page_name: StripePaymentLogPage, resource_type: RESOURCE_TYPE_STRIPE_PAYMENT_LOG},
	[USER_WITHDRAW_ROUTE]: {page_name: UserWithdrawPage, resource_type: RESOURCE_TYPE_USER_WITHDRAW},
	[PRIORITY_ACH_PAYMENT_ROUTE]: {page_name: PriorityACHPaymentPage, resource_type: RESOURCE_TYPE_PRIORITY_ACH_PAYMENT},
	[PRIORITY_ACH_RECURRING_PAYMENT_ROUTE]: {page_name: PriorityACHRecurringPaymentPage, resource_type: RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT},
	[LOAN_APPLICATION_ROUTE]: {page_name: LoanApplicationPage, resource_type: RESOURCE_TYPE_LOAN_APPLICATION},
	[LOAN_SYSTEM_INFO_ROUTE]: {page_name: LoanSystemInfoPage, resource_type: RESOURCE_TYPE_LOAN_SYSTEM_INFO},
	[LOAN_ROUTE]: {page_name: LoanPage, resource_type: RESOURCE_TYPE_LOAN},
	[LOAN_HISTORY_ROUTE]: {page_name: LoanHistoryPage, resource_type: RESOURCE_TYPE_LOAN_HISTORY},
	[LOAN_PAYMENT_LOG_ROUTE]: {page_name: LoanPaymentLogPage, resource_type: RESOURCE_TYPE_LOAN_PAYMENT_LOG},
	[STRIPE_WEBHOOK_LOG_ROUTE]: {page_name: StripeWebhookLogPage, resource_type: RESOURCE_TYPE_STRIPE_WEBHOOK_LOG},
	[USER_ACCOUNT_PAYMENT_PROVIDER_INFO_ROUTE]: {page_name: UserAccountPaymentProviderInfoPage, resource_type: RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO},
	[SEZZLE_ORDER_ROUTE]: {page_name: SezzleOrderPage, resource_type: RESOURCE_TYPE_SEZZLE_ORDER},
	[SEZZLE_WEBHOOK_EVENT_ROUTE]: {page_name: SezzleWebhookEventPage, resource_type: RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT},
	[BANK_ACCOUNT_ROUTE]: {page_name: BankAccountPage, resource_type: RESOURCE_TYPE_BANK_ACCOUNT},
	[BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_ROUTE]: {page_name: BankAccountHistoricalInterestRatePage, resource_type: RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE},
	[BANK_ACCOUNT_INTEREST_ROUTE]: {page_name: BankAccountInterestPage, resource_type: RESOURCE_TYPE_BANK_ACCOUNT_INTEREST},
	[BANK_ACCOUNT_BALANCE_RECORD_ROUTE]: {page_name: BankAccountBalanceRecordPage, resource_type: RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD},
	[BANK_TRANSFER_ROUTE]: {page_name: BankTransferPage, resource_type: RESOURCE_TYPE_BANK_TRANSFER},
	[BULK_FUNDS_TRANSFER_ROUTE]: {page_name: BulkFundsTransferPage, resource_type: RESOURCE_TYPE_BULK_FUNDS_TRANSFER},
	[FUNDS_LOCK_ROUTE]: {page_name: FundsLockPage, resource_type: RESOURCE_TYPE_FUNDS_LOCK},
	[FUNDS_LOCK_RELEASE_LOG_ROUTE]: {page_name: FundsLockReleaseLogPage, resource_type: RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG},
	[RELEASED_FUNDS_LOCK_ROUTE]: {page_name: ReleasedFundsLockPage, resource_type: RESOURCE_TYPE_RELEASED_FUNDS_LOCK},
	[BALANCE_SOURCE_TRANSFER_ROUTE]: {page_name: BalanceSourceTransferPage, resource_type: RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER},
	[CREDIT_USER_ACCOUNT_LOG_ROUTE]: {page_name: CreditUserAccountLogPage, resource_type: RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG},
	[EVENT_ROUTE]: {page_name: EventPage, resource_type: RESOURCE_TYPE_EVENT},
	[EVENT_HOOK_ROUTE]: {page_name: EventHookPage, resource_type: RESOURCE_TYPE_EVENT_HOOK},
	[NOTIFICATION_ROUTE]: {page_name: NotificationPage, resource_type: RESOURCE_TYPE_NOTIFICATION},
	[ACTION_ITEM_ROUTE]: {page_name: ActionItemPage, resource_type: RESOURCE_TYPE_ACTION_ITEM},
	[UPDATE_LOG_ROUTE]: {page_name: UpdateLogPage, resource_type: RESOURCE_TYPE_UPDATE_LOG_ENTRY},
	[STORAGE_FILE_ROUTE]: {page_name: StorageFilePage, resource_type: RESOURCE_TYPE_STORAGE_FILE},
	[ATTACHED_STORAGE_FILES_ROUTE]: {page_name: AttachedStorageFilesPage, resource_type: RESOURCE_TYPE_ATTACHED_STORAGE_FILES},
	[SYSTEM_HISTORY_ENTRY_ROUTE]: {page_name: SystemHistoryEntryPage, resource_type: RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY},
	[SNAPSHOT_ROUTE]: {page_name: SnapshotPage, resource_type: RESOURCE_TYPE_SNAPSHOT},
	[IP_ADDRESS_ROUTE]: {page_name: IPAddressPage, resource_type: RESOURCE_TYPE_IP_ADDRESS},
	[KNOWN_IP_ADDRESS_ROUTE]: {page_name: KnownIPAddressPage, resource_type: RESOURCE_TYPE_KNOWN_IP_ADDRESS},
	[USER_AGENT_ROUTE]: {page_name: UserAgentPage, resource_type: RESOURCE_TYPE_USER_AGENT},
	[KNOWN_USER_AGENT_ROUTE]: {page_name: KnownUserAgentPage, resource_type: RESOURCE_TYPE_KNOWN_USER_AGENT},
	[SYSTEM_STATS_ROUTE]: {page_name: SystemStatsPage, resource_type: RESOURCE_TYPE_SYSTEM_STATS},
	[RESOURCE_NOTE_ROUTE]: {page_name: ResourceNotePage, resource_type: RESOURCE_TYPE_RESOURCE_NOTE},
	[DEPOSIFY_TAG_ROUTE]: {page_name: DeposifyTagPage, resource_type: RESOURCE_TYPE_DEPOSIFY_TAG},
	[PERMANENT_LINK_ROUTE]: {page_name: PermanentLinkPage, resource_type: RESOURCE_TYPE_PERMANENT_LINK},
	[ONLINE_USER_ROUTE]: {page_name: OnlineUserPage, resource_type: RESOURCE_TYPE_ONLINE_USER},
	[FRONTEND_GENERAL_SETTINGS_ROUTE]: {page_name: FrontendGeneralSettingsPage, resource_type: RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS},
	[YARDI_SCREENING_WORKS_PRO_XML_ROUTE]: {page_name: YardiScreeningWorksProXMLPage, resource_type: RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML},
	[YARDI_VOYAGER_XML_ROUTE]: {page_name: YardiVoyagerXMLPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_XML},
	[YARDI_VOYAGER_TRANSACTION_ROUTE]: {page_name: YardiVoyagerTransactionPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION},
	[YARDI_VOYAGER_RESIDENT_ROUTE]: {page_name: YardiVoyagerResidentPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT},
	[YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_ROUTE]: {page_name: YardiVoyagerResidentCustomColumnPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN},
	[YARDI_VOYAGER_PROPERTY_UNIT_ROUTE]: {page_name: YardiVoyagerPropertyUnitPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT},
	[YARDI_VOYAGER_PROPERTY_ROUTE]: {page_name: YardiVoyagerPropertyPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY},
	[YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_ROUTE]: {page_name: YardiVoyagerPMCServiceInterfaceVersionPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION},
	[YARDI_VOYAGER_PMC_ROUTE]: {page_name: YardiVoyagerPMCPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PMC},
	[YARDI_VOYAGER_PMC_CREDENTIALS_ROUTE]: {page_name: YardiVoyagerPMCCredentialsPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS},
	[YARDI_VOYAGER_PET_ROUTE]: {page_name: YardiVoyagerPetPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PET},
	[YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_ROUTE]: {page_name: YardiVoyagerILSGuestCardEventPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT},
	[YARDI_VOYAGER_CHARGE_ROUTE]: {page_name: YardiVoyagerChargePage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_CHARGE},
	[YARDI_VOYAGER_CHARGE_CODE_ROUTE]: {page_name: YardiVoyagerChargeCodePage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE},
	[YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_ROUTE]: {page_name: YardiVoyagerDepositCreateIntentPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT},
	[YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_ROUTE]: {page_name: YardiVoyagerDepositCloseIntentPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT},
	[YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_ROUTE]: {page_name: YardiVoyagerDepositWithholdIntentPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT},
	[YARDI_VOYAGER_EVENT_ROUTE]: {page_name: YardiVoyagerEventPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_EVENT},
	[YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_ROUTE]: {page_name: YardiVoyagerFlexDepositIntentPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT},
	[YARDI_VOYAGER_PHONE_ROUTE]: {page_name: YardiVoyagerPhonePage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PHONE},
	[YARDI_VOYAGER_OTHER_OCCUPANT_ROUTE]: {page_name: YardiVoyagerOtherOccupantPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT},
	[YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_ROUTE]: {page_name: YardiVoyagerPMCCustomColumnSettingsPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS},
	[YARDI_VOYAGER_PMC_STATS_ROUTE]: {page_name: YardiVoyagerPMCStatsPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS},
	[YARDI_VOYAGER_PMC_STATS_COLLECTOR_ROUTE]: {page_name: YardiVoyagerPMCStatsCollectorPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR},
	[YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_ROUTE]: {page_name: YardiVoyagerActiveScanLogEntryPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY},
	[YARDI_VOYAGER_SYSTEM_SETTINGS_ROUTE]: {page_name: YardiVoyagerSystemSettingsPage, resource_type: RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS}
};

